import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";
import { servicesData } from "../../data/mockData";

const carpetCard = servicesData.services.find((s) => s.id === "svc-carpet");

const CarpetCleaningPage = () => {
  const pageData = {
    pageTitle: "Carpet Cleaning Cardiff | Hot Water Extraction | NeatWave",
    metaDescription: "Carpet and upholstery cleaning in Cardiff, Barry and Penarth. Hot water extraction lifts stains and pet odours, with pet-safe products and 2-4 hour drying. Rooms from £30.",
    quoteService: "Carpet Cleaning",
    heroImageAlt: "Professional hot water extraction carpet cleaning in a Cardiff home",

    heroTitle: "Carpet Cleaning in Cardiff",
    heroSubtitle: "Deep hot water extraction cleaning to restore your carpets, eliminate odours, and remove stubborn stains.",
    heroImage: carpetCard.image,

    serviceDescription: (
      <>
        <p className="mb-4">
          Our carpet cleaning uses professional <strong>hot water extraction (steam cleaning)</strong>. Heated water and cleaning solution are driven deep into the carpet pile, then extracted together with the dirt, allergens and bacteria that everyday vacuuming leaves behind.
        </p>
        <p className="mb-4">
          We use <strong>eco-friendly, non-toxic solutions that are safe for children and pets</strong>. Our powerful extraction leaves carpets only slightly damp, so they are typically <strong>dry within 2-4 hours</strong>.
        </p>
        <p className="mb-4">
          From <strong>pet stains and odours</strong> to coffee spills and high-traffic marks, we target tough spots with pre-treatment before the deep clean. Regular professional cleaning also helps <strong>prolong the life of your carpets</strong> by removing the grit that wears fibres down.
        </p>
      </>
    ),

    whatIncluded: [
      { title: "Vacuum & Pre-treatment", description: "High-power vacuuming and pre-treatment of tough spots and stains" },
      { title: "Hot Water Extraction", description: "Deep steam cleaning that lifts embedded dirt from the base of the pile" },
      { title: "Deodorise & Sanitise", description: "Deodorising and sanitisation treatment for a fresh, hygienic finish" },
      { title: "Every Room Covered", description: "Hallways, stairs, single and double bedrooms, and living room carpets" },
      { title: "Pet Stain & Odour Removal", description: "Targeted treatment that neutralises pet accidents and lingering smells" },
      { title: "Eco-Friendly & Pet-Safe", description: "Non-toxic solutions that are safe for children and pets, with fast drying" },
    ],

    pricingInfo: {
      duration: "2-4 hours drying",
      price: "From £30",
      note: "Use our quote calculator for an instant estimate based on your rooms, living room and stairs, then request a free quote.",
    },

    priceList: [
      { item: "Single Bedroom / Small Room", price: "From £30" },
      { item: "Double Bedroom / Living Room", price: "From £40" },
      { item: "Hallway & Flight of Stairs", price: "From £35" },
      { item: "Whole House / Multi-Room Package", price: "From £110" },
    ],

    faqs: [
      { q: "How much does carpet cleaning cost in Cardiff?", a: "Single rooms start from £30, double bedrooms or living rooms from £40, and a hallway and flight of stairs from £35. Use our quote calculator for an instant estimate." },
      { q: "How long do carpets take to dry?", a: "Typically 2 to 4 hours depending on ventilation and room temperature." },
      { q: "Do you move furniture?", a: "We move light items like chairs and side tables. Heavy wardrobes or beds should be cleared beforehand." },
      { q: "Are products safe for pets?", a: "Yes. We use eco-friendly, non-toxic solutions that are safe for children and pets." },
    ],

    testimonial: {
      text: "Jefferson from Neatwave did a fantastic job of cleaning it and left the place spotless. Very happy with the service. Thank you!",
      author: "Ash Heath, Google review",
    },

    relatedServices: [
      { title: "End of Tenancy Cleaning", description: "Deposit-ready deep cleans for moving out", url: "/end-of-tenancy-cleaning-cardiff" },
      { title: "Deep Cleaning", description: "A top-to-bottom refresh for your home", url: "/deep-cleaning-cardiff" },
      { title: "Airbnb Cleaning", description: "Turnover cleans with fresh linen between guests", url: "/airbnb-cleaning-cardiff" },
    ],
  };

  return <ServicePageTemplate {...pageData} />;
};

export default CarpetCleaningPage;
